module.exports = __webpack_public_path__ + "static/media/Birani.ca382edb.png";